import { UseQueryOptions } from 'react-query';
import useQuery from 'hooks/useQuery';
import { CuredApiPaths } from 'models/enums';
import { PathWithID } from 'models/types';
import QueryKeys from './keys';
import { ContentType, VoiceCallContent } from 'domains/content/types';

type UseVoiceTemplateParams = {
    voiceTemplateId?: string;
    type?: ContentType;
    reactQueryOptions?: UseQueryOptions<VoiceCallContent, Error>;
};

const useVoiceTemplateById = ({ voiceTemplateId, type, reactQueryOptions }: UseVoiceTemplateParams) =>
    useQuery<VoiceCallContent>(
        QueryKeys.VOICE_TEMPLATE_ID(Number(voiceTemplateId)),
        `${new PathWithID(CuredApiPaths.VOICE_TEMPLATES, voiceTemplateId).url}?type=${type}`,
        reactQueryOptions
    );

export default useVoiceTemplateById;
